import { render } from "./ad-detail.vue?vue&type=template&id=625a9818&scoped=true"
import script from "./ad-detail.vue?vue&type=script&lang=js"
export * from "./ad-detail.vue?vue&type=script&lang=js"

import "./ad-detail.vue?vue&type=style&index=0&id=625a9818&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-625a9818"]])

export default __exports__